/*eslint-disable*/
import { createSlice } from '@reduxjs/toolkit'

// actions
import { fetchReviews, fetchOpenCampiagn, fetchClosedCampiagn } from '../actions/reviews'

const initialState = {
    status: 'idle',
    reviews: [],
    openReviews: [],
    closedReviews: [],
    openCampiagns: [],
    closedCampiagns: [],
    
    loading: {
        openCampiagns: false,
        closedCampiagns: false,
        reviews: false,
    },
    error: null,
  }

export const campaignReviewSlice = createSlice({
    name: 'campaignReview',
    initialState,
    reducers: {},
    extraReducers(builder) {
      builder
        .addCase(fetchReviews.pending, (state) => {
          state.status = 'loading'
          state.reviews = {}
          state.error = undefined
        })
        .addCase(fetchReviews.fulfilled, (state, action) => {
          state.status = 'succeeded'
          state.error = undefined
          const allReviews = action?.payload?.resources?.data || []
          state.reviews = allReviews

          state.openReviews = allReviews.filter((review)=>
            review.decision === 'UNREVIEWED'
          )

          state.closedReviews = allReviews.filter((review) =>
            review.decision === 'APPROVE'
          )

        })
        .addCase(fetchReviews.rejected, (state, action) => {
          state.status = 'failed'
          state.reviews = {}
          state.error = action.error.message
        })
        
        //open campaigns
        .addCase(fetchOpenCampiagn.pending, (state) => {
          state.loading.openCampiagns = true
          state.error = undefined
        })
        .addCase(fetchOpenCampiagn.fulfilled, (state, action) => {
          state.loading.openCampiagns = false
          state.openCampiagns = action?.payload?.resources?.data || []
          state.error = undefined 
        })
        .addCase(fetchOpenCampiagn.rejected, (state, action) => {
          state.loading.openCampiagns = false
          state.error = action.error.message
        })

        //closed campaigns
        .addCase(fetchClosedCampiagn.pending, (state) => {
          state.loading.closedCampiagns = true
          state.error = undefined
        })
        .addCase(fetchClosedCampiagn.fulfilled, (state, action) => {
          state.loading.closedCampiagns = false
          state.closedCampiagns = action?.payload?.resources?.data || []
          state.error = undefined 
        })
        .addCase(fetchClosedCampiagn.rejected, (state, action) => {
          state.loading.closedCampiagns = false
          state.error = action.error.message
        })        


    }
  })

  export default campaignReviewSlice.reducer
  export const getCampaignReviewCallStatus = (state) => state.reviews.status
  export const getOpenReviews = (state) => state.reviews.openReviews
  export const getClosedReviews = (state) => state.reviews.closedReviews
  
  export const getAccountOpenCampaigns = (state) => {
    const {openCampiagns, reviews} = state.reviews
    const reviewList = Array.isArray(reviews) ? reviews : []
    const campaignList = Array.isArray(openCampiagns) ? openCampiagns : []
    const campaignIds = new Set(
        reviewList.map((review) => review.campaignId)
    )

    return campaignList.filter((campaign) => campaignIds.has(campaign.id))
  }

  export const getAccountClosedCampaigns = (state) => {
    const {closedCampiagns, reviews} = state.reviews
    const reviewList = Array.isArray(reviews) ? reviews : []
    const campaignList = Array.isArray(closedCampiagns) ? closedCampiagns : []
    const campaignIds = new Set(
        reviewList.map((review) => review.campaignId)
    )

    return campaignList.filter((campaign) => campaignIds.has(campaign.id))
  }